"use strict";

var React = require("react");

var SvgIconUnarchive = function SvgIconUnarchive() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
    },
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M20.54 5.23c.29.34.46.77.46 1.27V19a2 2 0 01-2 2H5a2 2 0 01-2-2V6.5c0-.5.17-.93.46-1.27l1.38-1.68C5.12 3.21 5.53 3 6 3h12c.47 0 .88.21 1.15.55l1.39 1.68M5.12 5h13.75l-.94-1h-12l-.81 1M12 9.5L6.5 15H10v2h4v-2h3.5L12 9.5z",
    })
  );
};

exports["foreignIcon"] = SvgIconUnarchive;
